<template>
  <div v-if="show" class="card card-material card-side">
    <div v-on:click.self="openFilter()" class="card-body pb-0 card-material" :class="{ 'active': isActive }">
      <div v-on:click.self="openFilter()" class="card-title card-material-title" :class="{ 'clear-select': sideValue }">
        HPL zijde {{ side }}
        <div v-if="sideValue" class="float-right">
          <span class="badge badge-selected">
            {{ selectedName }}
          </span>
          <span class="badge badge-image-selected">
            <!-- <img :src="sideValue.image" :alt="sideValue.label" class="img-fluid image-selected-side">-->
            <img src="/images/sides/side5.png" :alt="sideValue.label" class="img-fluid image-selected-side">
          </span>
        </div>
        <font-awesome-icon v-if="showFilter && sideValue" class="font-awesome-icon action angle-up hidefilter" v-on:click.stop.prevent="hideFilter" icon="angle-up"/>
      </div>

      <div v-if="showFilter">
        <div class="select-type">
          <div class="form-group">
            <v-select placeholder="Zoek op code of omschrijving" v-model="sideValue" :filter-by="filterSides" :options="sides" ref="dropdown">
              <template slot="option" slot-scope="option">
                <span class="side-select-label">{{ option.label }}</span>
                {{ option.description }}
              </template>
            </v-select>
          </div>
        </div>

        <div class="row pb-2 float-right">
          <div @click="searchSides" class="side-list link">
            Bekijk decorlijst
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { MUTATE_SIDE_1, MUTATE_SIDE_2, SET_MATERIAL_SIDE, SET_DISABLE_PANEL_INPUT } from '../../../store/types'
  import { EventBus } from '../../../bus'

  export default {
    props: ['side'],
    data() {
      return {
        showFilter: false,
        filterSides: (option, label, search) => {
          let keyword = search.toLowerCase()
          return option.label.toLowerCase().indexOf(keyword) > -1 || option.description.toLowerCase().indexOf(keyword) > -1
        }
      }
    },
    computed: {
      sideValue: {
        get() {
          let side = this.$store.getters.materialSide(this.side)
          if (side && !side.code) {
            // Search side by code (supporting older offers)
            let value = this.$store.getters.side(parseInt(side))
            if (value) {
              return value
            }
          }
          return !side ? false : side
        },
        set(value) {
          if (value !== this.sideValue) {
            // this.$store.dispatch(SET_MATERIAL_SIDE, { sideType: this.side, sideValue: null })
            if (parseInt(this.side) === 2) {
              this.$store.commit(MUTATE_SIDE_2, value)
            } else {
              this.$store.commit(MUTATE_SIDE_1, value)

              EventBus.$emit('reset-finish-selection')
            }
            this.$store.dispatch(SET_DISABLE_PANEL_INPUT)
          }
          this.showFilter = false
        }
      },
      sides() {
        return this.$store.getters.sides
      },
      show() {
        // This should only show if 'HPL' is selected
        if (parseInt(this.side) === 1) {
          return !this.$store.getters.materialThickness ? false : this.$store.getters.materialThickness && this.$store.getters.filterFirst.indexOf('HPL') !== -1
        } else {
          return !this.$store.getters.material.side1 ? false : this.$store.getters.material.side1 && this.$store.getters.filterFirst.indexOf('HPL') !== -1
        }
      },
      isActive() {
        if (parseInt(this.side) === 1) {
          return this.showFilter || !this.$store.getters.material.side1
        } else {
          return this.showFilter && this.$store.getters.material.side1
        }
      },
      material() {
        return !this.$store.getters.material ? false : this.$store.getters.material
      },
      selectedName() {
        if (this.sideValue) {
          return this.sideValue.label
        }

        return ''
      }
    },
    watch: {
      selected: function(newValue) {
        // Update the material side
        this.$store.dispatch(SET_MATERIAL_SIDE, { sideType: this.side, sideValue: newValue })
      }
    },
    methods: {
      selectSide(side) {
        this.$store.dispatch(SET_MATERIAL_SIDE, { sideType: this.side, sideValue: side })
        this.$store.dispatch(SET_DISABLE_PANEL_INPUT)
        this.hideFilter()
      },
      searchSides() {
        this.$emit('searchSides')
      },
      openFilter() {
        if (this.sideValue && this.showFilter) {
          this.showFilter = false
        } else {
          this.showFilter = true
        }
      },
      hideFilter() {
        if (this.sideValue) {
          this.showFilter = false
        }
      }
    },
    updated() {
      this.showFilter = (this.$store.getters.loadingMaterial) ? false : (!this.sideValue) ? true : this.showFilter
    }
  }
</script>

<style lang="scss" scoped>
  .card-title {
    font-weight: bold;
  }

  .side-list {
    font-size: 0.9em;
  }

  .side-select-label {
    color: $light-grey
  }

  .vs__dropdown-menu {
    width: 10000px;
  }

  .card-type {
    text-align: center;
    font-weight: bold;
  }
</style>
